import React, { useEffect, useState } from "react";
import { Loader2, Download, Mail, RefreshCw } from "lucide-react";
import { adminListSubscribers, getToken, adminExportSubscribersUrl } from "../../lib/api";
import { useToast } from "../../hooks/use-toast";

export default function SubscribersPanel() {
  const { toast } = useToast();
  const [subs, setSubs] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    adminListSubscribers()
      .then(setSubs)
      .catch(() => toast({ title: "Could not load subscribers" }))
      .finally(() => setLoading(false));
  };
  useEffect(load, []); // eslint-disable-line react-hooks/exhaustive-deps

  const exportCsv = async () => {
    try {
      const res = await fetch(adminExportSubscribersUrl, { headers: { Authorization: `Bearer ${getToken()}` } });
      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url; a.download = "subscribers.csv"; a.click();
      window.URL.revokeObjectURL(url);
    } catch {
      toast({ title: "Export failed" });
    }
  };

  const fmt = (iso) => { try { return new Date(iso).toLocaleDateString("en-GB"); } catch { return iso; } };

  return (
    <div data-testid="subscribers-panel">
      <div className="flex items-center justify-between gap-4 mb-6 flex-wrap">
        <p className="text-homi-body text-sm">{subs.length} subscriber{subs.length !== 1 && "s"}</p>
        <div className="flex gap-3">
          <button onClick={load} className="inline-flex items-center gap-2 text-sm font-heading font-semibold text-homi-goldDark"><RefreshCw className="w-4 h-4" /> Refresh</button>
          <button data-testid="subscribers-export" onClick={exportCsv} disabled={!subs.length}
            className="inline-flex items-center gap-2 bg-homi-gold hover:bg-homi-goldDark text-homi-black font-heading font-bold text-sm px-4 py-2 rounded-lg transition-colors disabled:opacity-50">
            <Download className="w-4 h-4" /> Export CSV
          </button>
        </div>
      </div>

      {loading ? (
        <div className="flex items-center justify-center py-20"><Loader2 className="w-8 h-8 animate-spin text-homi-gold" /></div>
      ) : subs.length === 0 ? (
        <div className="text-center py-20 text-gray-400">No subscribers yet.</div>
      ) : (
        <div className="bg-white border border-gray-100 rounded-2xl shadow-sm overflow-hidden">
          {subs.map((s, i) => (
            <div key={s.email} data-testid={`subscriber-row-${i}`} className={`flex items-center justify-between gap-4 px-5 py-4 ${i !== subs.length - 1 ? "border-b border-gray-100" : ""}`}>
              <span className="inline-flex items-center gap-2 text-homi-black"><Mail className="w-4 h-4 text-homi-goldDark" />{s.email}</span>
              <span className="text-sm text-gray-400">{fmt(s.created_at)}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
